@if (!this.isServerAvailable) {
    <div @serverAvailableInOutTrigger class="flex h-8 items-center justify-center bg-[#f8d7da] text-center text-lg text-[#721c24]">
        Es besteht keine Verbindung zum Server
    </div>
}
